import { useFormContext } from "react-hook-form";
import { GeometrisDeviceInput } from "../../../common/data/service-proxies";
import { HookFormSimpleForm } from "../../common/form/hook-form/HookFormSimpleForm";
import { GeometrisDeviceSelectorInput } from "./GeometrisDeviceSelectorInput";

interface Props {}

export const GeometrisSelectDeviceCommandForm = (props: Props) => {
  const { control } = useFormContext<GeometrisDeviceInput>();
  return (
    <HookFormSimpleForm {...props}>
      <GeometrisDeviceSelectorInput<GeometrisDeviceInput>
        {...props}
        control={control}
      />
    </HookFormSimpleForm>
  );
};
